import { DEVIATIONS_PROP } from '../consts';

/**
 * @typedef {Object} DeviationContextFunction
 * @property {string} name
 * @property {Function} func
 * @property {string} summary
 * @typedef {Object} DeviationContext
 * @property {DeviationContextFunction} GET_BY_PATH
 * @property {DeviationContextFunction} ABS
 * @property {DeviationContextFunction} SQUARE
 * @property {DeviationContextFunction} SQRT
 * @property {DeviationContextFunction} PCT
 */

/**
 * @readonly
 * @type {DeviationContext}
 */
export const DeviationContext = Object.freeze({
    GET_BY_PATH: {
        name: '$',
        func: (key) => key,
        get summary() {
            return `Извлекает значение по индексу источника и имени показателя: ${this.name}('0.Метрика')`;
        }
    },
    ABS: {
        name: 'АБС',
        func: (a) => Math.abs(a),
        get summary() {
            return `Возвращает модуль значения: ${this.name}(-12)`;
        }
    },
    SQUARE: {
        name: 'КВДТ',
        func: (a) => a ** 2,
        get summary() {
            return `Возводит значение в квадрат: ${this.name}(12)`;
        }
    },
    SQRT: {
        name: 'КРН',
        func: (a) => Math.sqrt(a),
        get summary() {
            return `Извлекает квадратный корень из значения: ${this.name}(12)`;
        }
    },
    PCT: {
        name: 'ПРЦТ',
        func: (a, b) => Math.abs((a - b) / b) * 100,
        get summary() {
            return `Рассчитывает процентное отклонение: ${this.name}(12, 34)`;
        }
    }
});

export const DeviationsLabelMap = Object.freeze({
    [`${DEVIATIONS_PROP}.refDatasetIndex`]: 'Эталонный источник',
    [`${DEVIATIONS_PROP}.refDatasetKey`]: 'Ключ эталонного источника',
    [`${DEVIATIONS_PROP}.datasets`]: 'Настройки источников',
    [`${DEVIATIONS_PROP}.datasets.index`]: 'Источник',
    [`${DEVIATIONS_PROP}.datasets.key`]: 'Ключ источника',
    [`${DEVIATIONS_PROP}.rules`]: 'Настройки отклонений',
    [`${DEVIATIONS_PROP}.rules.name`]: 'Наименование',
    [`${DEVIATIONS_PROP}.rules.formula`]: 'Формула расчета'
});

export const DeviationsHintMap = Object.freeze({
    [`${DEVIATIONS_PROP}.refDatasetKey`]:
        `Измерение должно иметь полный список значений,
        которые могут присутствовать в дополнительных
        источниках`
});

export const DEVIATION_DEFAULT_VALUE = 0;
export const DEVIATION_RULE_NAME_PREFIX = 'Отклонение';

export const DeviationFormulaAllowedTokens = [
    '\\+',
    '-',
    '\\/',
    '\\*',
    '\\(',
    '\\)',
    '\'',
    '\\s',
    '\\d',
    '\\.',
    ','
];
